import { render, staticRenderFns } from "./DynamicStatistics.vue?vue&type=template&id=af2937a6&"
import script from "./DynamicStatistics.vue?vue&type=script&lang=js&"
export * from "./DynamicStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports